import React, { useState, useEffect } from 'react'
import Icon from 'meinian-package/src/component/icon'
import Button from 'meinian-package/src/baseComponent/button'
import globalData from 'meinian-package/src/common/globalData'
import { IMAGE_DETAIL_FORCE_GUIDE_STEP_KEY } from '../forceGuideConfig'
import styles from './index.module.less'

type TForceGuidePanel={
  onClose?: ()=>void,
  positions: Array<DOMRect>
}

export default ({ onClose, positions }:TForceGuidePanel) => {
  const [step, setStep] = useState(null)

  useEffect(() => {
    globalData.get(IMAGE_DETAIL_FORCE_GUIDE_STEP_KEY, setStep, 1)
  }, [])

  const onStep = (val) => {
    setStep(val)
    globalData.set(IMAGE_DETAIL_FORCE_GUIDE_STEP_KEY, val)
  }

  return <div className={styles.forceGuideWrap}>
    <div className={styles.forceGuideMark} />
    {
        step === 1 && positions[0]?.width && <Step1 onClose={onClose} position={positions[0]} onNext={() => onStep(2)} />
    }
    {
        step === 2 && positions[1]?.width && <Step2 onClose={onClose} position={positions[1]} />
    }
  </div>
}

const Step1 = ({ onClose, position, onNext }) => {
  return <div className={styles.imageDetailForceGuideStep1Wrap}>
    <div
      className={styles.tipDom}
      style={{
        left: position?.left,
        top: position?.top,
        width: position?.width,
        height: position?.height
      }}
    >
      <img className={styles.tipDomImage} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/imageDetailActionPanel.png" />
      <div className={styles.tip}>
        <div className={styles.forceGuidePanelClose} onClick={onClose}>
          <Icon type="m-guanbi" />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>通过审核挑选出符合要求的款式</div>
          <div className={styles.footer}>
            <span style={{ marginRight: '16px' }}>(1/2)</span>
            <Button onClick={onNext}>下一步</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
}

const Step2 = ({ onClose, position }) => {
  return <div className={styles.imageDetailForceGuideStep2Wrap}>
    <div
      className={styles.tipDom}
      style={{
        // eslint-disable-next-line no-unsafe-optional-chaining
        left: position?.left - 40,
        // eslint-disable-next-line no-unsafe-optional-chaining
        top: position?.top + 174,
        width: 40,
        height: 232
      }}
    >
      <img className={styles.tipDomImage} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/imageDetailActionPanel2.png" />
      <div className={styles.tip}>
        <div className={styles.forceGuidePanelClose} onClick={onClose}>
          <Icon type="m-guanbi" />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>批注：</div>
          <div className={styles.text}>在图片上任意表达写下想法</div>
          <div className={styles.title} style={{ marginTop: '74px' }}>评论：</div>
          <div className={styles.text}>留言点评，表达观点</div>
          <div className={styles.footer}>
            <span style={{ marginRight: '16px' }}>(2/2)</span>
            <Button onClick={onClose}>完成</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
